import { createTheme, alpha } from '@material-ui/core/styles';
import transitions from '@material-ui/core/styles/transitions';

const theme = createTheme({
  // palette: {
  // primary: '#044ada'
  // },
  typography: {
    fontFamily: 'IBM Plex Sans',
  },
  overrides: {
    MuiBackdrop: {
      root: {
        backgroundColor: 'rgba(0, 0, 0, 0.10)'
      }
    },
    MuiTypography: {
      root: {
        fontFamily: 'IBM Plex Sans',
      }
    },
    MuiInputLabel: {
      outlined: {
        '&.$MuiInputLabel-shrink': {
          transform: 'translate(0, -18px) scale(1)'
        }

      },
      shrink: {
        transform: 'translate(0, -18px) scale(1)'
      },
      root: {
        color: '#0430ad',
        fontWeight: 500,
        fontSize: '14px',
        display: 'unset',
      },
      formControl: {
        top: '0',
      },
    },
    MuiFormLabel: {
      root: {
        color: '#0430ad',
        fontWeight: 500,
        fontSize: '14px',
        display: 'unset',
        marginBottom: '5px',
      },
    },
    // MuiInput: {
    //   root: {
    //     '& input:valid + fieldset': {
    //       borderColor: 'green',
    //       borderWidth: 2,
    //     },
    //     '& input:invalid + fieldset': {
    //       borderColor: 'red',
    //       borderWidth: 1,
    //     },
    //   },
    // },
    // MuiInputBase: {
    //   input: {
    //     // color: '#5e6784',
    //     color: '#02032a',
    //     borderRadius: '4px',
    //     position: 'relative',
    //     backgroundColor: '#fff',
    //     border: '1px solid #ced4da',
    //     fontSize: 16,
    //     padding: '10px 12px',
    //     transition: transitions.create(['border-color', 'box-shadow']),
    //     '&.$Mui-disabled': {
    //       backgroundColor: '#f7f7fa',
    //       borderColor: '#c2c4d1',
    //     },
    //     '&.$Mui-error': {
    //       boxShadow: `${alpha('#da172e', 0.25)} 0 0 0 0.2rem`,
    //       borderColor: '#da3330',
    //     },
    //     '&:hover:not($disabled):not(:focus):not(:invalid)': {
    //       borderColor: '#000',
    //     },
    //     '&:focus': {
    //       boxShadow: `${alpha('#044ada', 0.25)} 0 0 0 0.2rem`,
    //       borderColor: '#044ada',
    //     },
    //     '&::placeholder': {
    //       opacity: 1,
    //       color: '#5e6784',
    //     },
    //   },
    // },
    MuiOutlinedInput: {
      root: {
        color: '#02032a',
        borderRadius: '4px',
        position: 'relative',
        backgroundColor: '#fff',
        border: '1px solid #ced4da',
        fontSize: 16,
        padding: '10px 12px',
        transition: transitions.create(['border-color', 'box-shadow']),
        '&.$Mui-disabled': {
          backgroundColor: '#f7f7fa',
          borderColor: '#c2c4d1',
        },
        '&.Mui-focused': {
          boxShadow: `${alpha('#044ada', 0.25)} 0 0 0 0.2rem`,
          border: '1px solid #044ada',
        },
        '&.$Mui-error': {
          boxShadow: `${alpha('#da172e', 0.25)} 0 0 0 0.2rem`,
          borderColor: '#da3330',
        },
        '&::placeholder': {
          opacity: 1,
          color: '#5e6784',
        },
      },
      input: {
        margin: 0,
        padding: 0,
        border: 'none',
        '&.$Mui-disabled': {
          backgroundColor: 'none',
          borderColor: 'none',
        },
        '&:hover:not($disabled):not(:focus)': {
          borderColor: 'none',
        },
        '&:focus': {
          boxShadow: 'none',
          borderColor: 'none',
        },
        '&::placeholder': {
          opacity: 1,
          color: '#5e6784',
        },
        '&:-webkit-autofill , &:-webkit-autofill:hover , &:-webkit-autofill:focus': {
          '-webkit-box-shadow': '0 0 0px 10px #fff inset',
        },
      },
      notchedOutline: {
        display: 'none',
      },
    },
    MuiFormHelperText: {
      root: {
        color: '#5e6784',
      },
      contained: {
        marginLeft: 0,
      }
    },
    MuiNativeSelect: {
      '&.$MuiInputLabel-shrink': {
        transform: 'translate(0, -18px) scale(0.75)'
      }
    },
    MuiSelect: {
      icon: {
        marginRight: '9px',
        color: '#6fceff',
      },
      selectMenu: {},
    },
    MuiAvatar: {
      root: {
        height: '48px',
        width: '48px',
      },
    },
    MuiChip: {
      root: {
        backgroundColor: '#fff',
        fontSize: 16,
        color: '#5e6784'
      }
    },
    MuiButton: {
      root: {
        border: 6,
        minHeight: 42,
      },
      label: {

        textTransform: 'none',
        fontSize: 14,
        fontWeight: 500,
        fontFamily: 'IBM Plex Sans',
      },
      text: {
        color: '#044ada',
        '&:hover:not($disabled):not(:focus)': {
          backgroundColor: '#044ada',
          color: '#fff',
        },
        '&:focus': {
          backgroundColor: '#044ada',
          color: '#fff',
          boxShadow: `${alpha('#c2c4d1', 0.25)} 0 0 0 3px`,
        },
        '&$disabled': {
          color: '#6892e8'
        }
      },
      colorInherit: {
        backgroundColor: '#fff',
        color: "#044ada",
        boxShadow: 'none',
        '&:hover:not($disabled):not(:focus)': {
          backgroundColor: '#edf4ff',
          boxShadow: 'none',
          border: 'solid 1px #97c1ff',
        },
        '&:focus': {
          backgroundColor: '#fff',
          color: "#044ada",
          border: 'solid 3px #c9ddff',
        },
        '&:active': {
          boxShadow: 'none',
        },
      },
      contained: {
        backgroundColor: '#044ada',
        color: "#fff",
        boxShadow: 'none',
        borderRadius: '6px',
        '&:hover:not($disabled):not(:focus)': {
          backgroundColor: '#0430ad',
          boxShadow: 'none',
        },
        '&:focus': {
          backgroundColor: '#044ada',
          color: '#fff',
          border: 'solid 3px #c2c4d1',
        },
        '&:active': {
          boxShadow: 'none',
        },
      },
      containedPrimary: {
        backgroundColor: '#56d679',
        color: "#02032a",
        boxShadow: 'none',
        '&:hover:not($disabled):not(:focus)': {
          backgroundColor: '#1a8038',
          boxShadow: 'none',
          color: "#fff"
        },
        '&:focus': {
          backgroundColor: '#56d679',
          color: '#fff',
        },
        '&:active': {
          boxShadow: 'none',
        },
      },
      containedSecondary: {
        backgroundColor: '#e71d32',
        color: "#fff",
        boxShadow: 'none',
        '&:hover:not($disabled):not(:focus)': {
          backgroundColor: '#ad1624',
          boxShadow: 'none',
        },
        '&:focus': {
          border: 'solid 3px #ffa5b4',
          backgroundColor: '#e71d32',
        },
      },
      outlined: {
        color: '#044ada',
        backgroundColor: '#fff',
        border: '1px solid #97c1ff',
        '&:hover:not($disabled):not(:focus)': {
          backgroundColor: '#edf4ff',
        },
        '&:focus': {
          backgroundColor: '#fff',
          boxShadow: `${alpha('#c9ddff', 0.25)} 0 0 0 3px`,
        },
      }
    },
    MuiSvgIcon: {
      root: {
        cursor: 'pointer'
      }
    },
    MuiStepIcon: {
      root: {
        width: 32,
        height: 32,
        color: '#c2c4d1'
      },
      text: {
        fontFamily: 'IBM  Plex Sans',
        fontSize: 12,
        fontWeight: 'bold',
        color: '#fff',
      },
      active: {
        color: '#0061ff!important'
      },
      completed: {
        color: '#00bab6!important'
      }
    },
    MuiStepLabel: {
      label: {
        fontFamily: 'IBM Plex Sans',
        fontSize: 16,
        color: '#5e6784'
      },
      active: {
        color: '#044ada!important',
        fontWeight: 500,
      },
      completed: {
        textTransform: 'none'
      }
    },
    MuiMobileStepper: {
      root: {
        backgroundColor: 'inherit'
      },
      dot: {
        width: 12,
        height: 12,
        backgroundColor: '#c2c4d1',
        margin: 4,
        transition: transitions.create(['background-color'])
      },
      dotActive: {
        width: 12,
        height: 12,
        backgroundColor: '#044ada',
        margin: 4,
        transition: transitions.create(['background-color'])
      }
    },
    MuiMenu: {
      paper: {
        borderRadius: '6px',
        boxShadow: '0 24px 40px -16px rgba(6, 31, 128, 0.2)',
        border: 'solid 1px #dfdfe6',
      },
    },
    MuiMenuItem: {
      root: {
        '&:hover': {
          backgroundColor: '#edf4ff',
        }
      }
    },
    MuiSnackbarContent: {
      message: {
        padding: 0
      }
    },
    MuiDialog: {
      paper: {
        boxShadow: '0 24px 40px -16px rgba(6, 31, 128, 0.2)',
        border: 'solid 1px #dfdfe6',
      }
    },
    MuiDialogActions: {
      root: {
        height: '66px',
        borderTop: '1px solid rgba(0, 0, 0, 0.12)',
      },
    },
    MuiDialogContent: {
      root: {
        padding: '16px 24px'
      }
    },
  },
});

export default theme;
